/** Prefixed reasons when canceling a single calendar/facility task occurrence. */
export const TASK_CANCEL_REASON_OTHER = 'Other'

export const TASK_CANCEL_REASON_OPTIONS: ReadonlyArray<{ value: string; text: string }> = [
  { value: 'Weather Conditions', text: 'Weather Conditions' },
  { value: 'Busy Area', text: 'Busy Area' },
  { value: 'Maintenance', text: 'Maintenance' },
  { value: 'Customer Request', text: 'Customer Request' },
  { value: TASK_CANCEL_REASON_OTHER, text: TASK_CANCEL_REASON_OTHER },
]
